import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, HostListener } from '@angular/core';

@Component({
  selector: 'div[data-component-type=checkbox]',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [trigger('checkAnimation', [
    state('checked', style({opacity: 1})),
    state('unchecked', style({opacity: 0})),
    transition('checked <=> unchecked', animate('300ms linear'))
  ])]
})
export class CheckboxComponent implements OnInit {

  @Input() label!: string
  @Input() value!: any
  checked: boolean = false
  @Output() valueChanges: EventEmitter<{checked: boolean, value: string}> = new EventEmitter()
  @Input() checkedValue!: any[]

  @HostListener('mousedown') update() {
    this.checked = !this.checked
    this.valueChanges.emit({checked: this.checked, value: this.value})
  }

  constructor() { }

  ngOnInit(): void {
    this.checked = this.checkedValue.indexOf(this.value) > -1
  }

}

export interface CheckBoxOptions {
  id: string,
  type: 'checkbox-component'
  label: string,
  value: any
  presence: boolean
}